import { getGlsBaseUrl } from '@/api/gls/get-gls-base-url';

/**
 * Builds the FGP update-authentication-token endpoint from the region-aware GLS
 * base. Returns `null` when no GLS base is configured.
 *
 * Mirrors casino-game-client's `${config.fgp.FGPUpdatePath}/authToken` (PATCH).
 */
export const getUpdateAuthenticationTokenEndpoint = (): string | null => {
  let base: string;

  try {
    base = getGlsBaseUrl();
  } catch {
    return null;
  }

  if (!base) {
    return null;
  }

  const trimmedBase = base.endsWith('/') ? base.slice(0, -1) : base;

  return `${trimmedBase}/cfg/api/v1/update/authToken`;
};
